export type UnsplashImageProps = {
  alt_description: string;
  id: string;
  links: { download_location: string };
  urls: { small: string };
  user: { links: { html: string }; name: string };
};

const UNSPLASH_API = "https://api.unsplash.com/search/photos";

const unsplashHeader = {
  Authorization: `Client-ID ${import.meta.env.VITE_UNSPLASH_KEY}`,
};

export const fetchUnsplashAPI = async (url: string) => {
  const response = await fetch(url, { headers: unsplashHeader });
  if (!response.ok) {
    throw new Error();
  }
  return response.json() as Promise<{ results: UnsplashImageProps[]; url: string }>;
};

export const fetchUnsplashImages = (query: string) => fetchUnsplashAPI(`${UNSPLASH_API}?page=1&query=${query}`);
